export const getValueInThousands = (value: number): number =>
  Math.round(value / 1000);
